type ReturnType = {
  filterQuery: string;
  pagination: {
    current: number;
  };
};

export function initializeFilterQueryAndPagination(url: URL): ReturnType {
  return {
    filterQuery: url.searchParams.toString(),
    pagination: {
      current: Number.parseInt(url.searchParams.get('page') || '1', 10),
    },
  };
}
